import React, { ReactNode } from 'react';
import { ICardProps } from '@mofid-securities/uikit';

export interface IBalanceCardProps
  extends Omit<
      React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
      >,
      'title'
    >,
    Omit<ICardProps, 'title'> {
  title: ReactNode;
  amount: ReactNode;
  currency: ReactNode;
  buttonTitle: ReactNode;
  buttonAction: () => void;
  isMasked?: boolean;
  onMaskChange?: (__isMasked: boolean) => void;
}

export interface IBalanceSlideSubComponentProps {
  isError?: boolean;
  isLoading?: boolean;
}
